import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Button,
  useTheme,
  Typography,
} from '@mui/material';

export const ThermostatClearPendingScheduleDialog = ({
  open,
  handleClearPendingSchedule,
  handleClose,
}: {
  open: boolean;
  handleClearPendingSchedule: () => void;
  handleClose: () => void;
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        alignItems: 'stretch',
        margin: 0,
        '& .css-1t1j96h-MuiPaper-root-MuiDialog-paper': {
          margin: 0,
          width: '100%',
        },
      }}
    >
      <DialogContent>
        <Typography variant="h3">
          Are you sure you want to clear the pending schedule?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Grid container rowSpacing={1} direction={'row'}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              color={'info'}
              sx={{ color: '#fff' }}
              onClick={() => {
                handleClearPendingSchedule();
                handleClose();
              }}
            >
              Clear Pending Schedule
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              sx={{ color: theme.embue.bad }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleClose();
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
